'use strict';

const getItemVariantName = (item) => {
    if (!item.variationAttributes) return '';
    const colorAttribute = item.variationAttributes.find(
        (attribute) => attribute.id === 'color'
    );
    if (colorAttribute) {
        return colorAttribute.displayValue;
    }
    return '';
};

const getItemPrice = (item) => {
    let result = {
        price: 0,
        discount: 0
    };

    if (item.price) {
        result.price = item.price.sales.value;
    }

    if (item.priceTotal && item.priceTotal) {
        if (item.priceTotal.nonAdjustedPriceValue) {
            result.discount = item.priceTotal.nonAdjustedPriceValue - item.priceTotal.priceValue;
        } else {
            result.discount = 0;
        }
    }

    return result;
};

const getDonationValue = (orderItems) => {
    const donationItem = orderItems.find((item) => item.isDonationItem);
    if (donationItem && donationItem.priceTotal && donationItem.priceTotal.priceValue) {
        return donationItem.priceTotal.priceValue;
    }
    return 0;
};

const buildItemsArray = (orderItems, options = {}) => {
    return orderItems.filter((item) => !item.isDonationItem).map((item, index) => {
        var gaItem = {
            item_id: item.id,
            item_name: item.productName,
            affiliation: 'Well People',
            currency: 'USD',
            discount: getItemPrice(item).discount,
            index: index,
            item_brand: 'Well People',
            item_category: item.primaryCategory,
            // item_category2: '', // Seems to be one level deep only in wellpeople
            item_list_name: options.itemListName !== undefined ? options.itemListName : item.primaryCategory,
            price: getItemPrice(item).price,
            quantity: item.quantity
        };

        if (getItemVariantName(item)) {
            gaItem.item_variant = getItemVariantName(item);
        }

        if (item.appliedCoupons && item.appliedCoupons.length > 0) {
            item.appliedCoupons.forEach((coupon, ind) => {
                if (ind === 0) {
                    gaItem.coupon = coupon;
                } else {
                    gaItem[`coupon${ind + 1}`] = coupon;
                }
            });
        }
        return gaItem;
    });
};

const addShippingInformation = (orderData, affiliation) => {
    if (!window.GAService) return;
    let itemsArray;
    let donationValue;
    if (orderData.items && orderData.items.items) {
        itemsArray = buildItemsArray(orderData.items.items, { itemListName: '' });
        donationValue = getDonationValue(orderData.items.items);
    }
    var hasGiftCard = false;
    var value = 0;
    var shippingMethod = '';
    var coupons = [];

    if (orderData.billing && orderData.billing.payment && orderData.billing.payment.selectedPaymentInstruments && orderData.billing.payment.selectedPaymentInstruments.length > 0) {
        hasGiftCard = orderData.billing.payment.selectedPaymentInstruments.some((paymentInstrument) => {
            return paymentInstrument.paymentMethod && paymentInstrument.paymentMethod === 'GIFT_CERTIFICATE';
        });
    }

    if (orderData.totals && orderData.totals.grandTotalValue) {
        value = orderData.totals.grandTotalValue;
    }

    if (orderData.shipping && orderData.shipping[0] && orderData.shipping[0].selectedShippingMethod) {
        shippingMethod = orderData.shipping[0].selectedShippingMethod.ID;
    }

    if (orderData.totals && orderData.totals.discounts && orderData.totals.discounts.length > 0) {
        orderData.totals.discounts.forEach((discount) => {
            if (discount.type === 'coupon' && discount.applied) {
                coupons.push(discount.couponCode);
            }
        });
    }

    const GAService = new window.GAService();
    GAService.addShippingInformation(
        itemsArray,
        hasGiftCard,
        affiliation,
        value,
        shippingMethod,
        coupons,
        donationValue
    );
};

const addBillingInformation = (orderData) => {
    if (!window.GAService) return;
    var hasGiftCard = false;
    var orderTotalValue = 0;
    var paymentMethod = [];
    var coupons = [];
    let itemsArray = [];
    let donationValue;
    if (orderData.items && orderData.items.items) {
        itemsArray = buildItemsArray(orderData.items.items, { itemListName: '' });
        donationValue = getDonationValue(orderData.items.items);
    }

    if (orderData.billing && orderData.billing.payment && orderData.billing.payment.selectedPaymentInstruments && orderData.billing.payment.selectedPaymentInstruments.length > 0) {
        hasGiftCard = orderData.billing.payment.selectedPaymentInstruments.some((paymentInstrument) => {
            return paymentInstrument.paymentMethod && paymentInstrument.paymentMethod === 'GIFT_CERTIFICATE';
        });
        paymentMethod = orderData.billing.payment.selectedPaymentInstruments.filter((paymentInstrument) => {
            return paymentInstrument.paymentMethod !== 'GIFT_CERTIFICATE';
        });
        paymentMethod = paymentMethod ? paymentMethod[0] : [];
    }
    if (orderData.totals && orderData.totals.discounts && orderData.totals.discounts.length > 0) {
        orderData.totals.discounts.forEach((discount) => {
            if (discount.type === 'coupon' && discount.applied) {
                coupons.push(discount.couponCode);
            }
        });
    }
    if (paymentMethod) {
        if (orderData.totals && orderData.totals.grandTotalValue) {
            orderTotalValue = orderData.totals.grandTotalValue;
        }
        const GAService = new window.GAService();
        GAService.addBillingInformation(
            itemsArray,
            hasGiftCard,
            orderTotalValue,
            paymentMethod.paymentMethod,
            coupons,
            donationValue
        );
    }
};

const purchaseEvent = (orderId, orderData, affiliation) => {
    if (!window.GAService) return;
    const GAService = new window.GAService();
    let itemsArray = [];
    const coupons = [];
    let donationValue;
    let hasGiftCard = false;
    let phoneNumber;
    if (orderData.items && orderData.items.items) {
        itemsArray = buildItemsArray(orderData.items.items, { itemListName: '' });
        donationValue = getDonationValue(orderData.items.items);
    }
    if (orderData.billing && orderData.billing.payment && orderData.billing.payment.selectedPaymentInstruments && orderData.billing.payment.selectedPaymentInstruments.length > 0) {
        hasGiftCard = orderData.billing.payment.selectedPaymentInstruments.some((paymentInstrument) => paymentInstrument.paymentMethod && paymentInstrument.paymentMethod === 'GIFT_CERTIFICATE');
    }
    if (orderData.totals && orderData.totals.discounts && orderData.totals.discounts.length > 0) {
        orderData.totals.discounts.forEach((discount) => {
            if (discount.type === 'coupon' && discount.applied) {
                coupons.push(discount.couponCode);
            }
        });
    }
    if (orderData.billing && orderData.billing.billingAddress && orderData.billing.billingAddress.address && orderData.billing.billingAddress.address.phone) {
        phoneNumber = orderData.billing.billingAddress.address.phone;
    }
    window.addEventListener('ga:pageDataEvent', () => {
        GAService.purchaseEvent(
            itemsArray,
            orderId,
            orderData.totals.grandTotalValue,
            orderData.totals.shippingValue,
            orderData.totals.totalTaxValue,
            affiliation,
            coupons,
            donationValue,
            hasGiftCard,
            orderData.orderEmail,
            phoneNumber
        );
    });
};

const promotionEvent = (promotionElement, eventName) => {
    try {
        const promotionData = JSON.parse(promotionElement.dataset.impressionDetails);
        const GAService = new window.GAService();
        GAService.promotionEvent(promotionData, eventName);
    } catch (e) {
        window.console.warn('Failed to parse GA4 promotion data');
    }
};

const genericAddToCartEvent = (productItems, eventValue) => {
    window.dataLayer = window.dataLayer || {};
    window.dataLayer.push({ecommerce: null});
    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: "USD", // Wellpeople only has one currency for now
            value: eventValue,
            items: productItems
        }
    })
}

const initializeEvents = () => {
    document.body.addEventListener('dyCarouselLoaded', (e) => {
        if (e.detail && e.detail.productIds) {
            const GAService = new window.GAService();
            GAService.buildEventFromProductIds(e.detail.productIds, 'view_item_list');
        }
    });

    document.body.addEventListener('dyProductClick', (e) => {
        if (e.detail && e.detail.productIds) {
            const GAService = new window.GAService();
            GAService.buildEventFromProductIds(e.detail.productIds, 'select_item');
        }
    });

    document.body.addEventListener('purchaseComplete', (e) => {
        if (e.detail && e.detail.order) {
            const orderData = e.detail.order;
            purchaseEvent(orderData.orderNumber, orderData, 'Well People');
        }
    });

    window.addEventListener('load', () => {
        const promotionElements = document.querySelectorAll('.ga4-promotion');
        promotionElements.forEach((promotion) => {
            promotionEvent(promotion, 'view_promotion');
            promotion.addEventListener('click', (e) => {
                promotionEvent(e.currentTarget, 'select_promotion');
            });
        });
    });
};

const pageMetaDataEvent = (pageType, pageTitle) => {
    try {
        const controllerUrl = window.reactSystemData.controllers.page.pageMetaData;
        fetch(`${controllerUrl}?pageType=${pageType}&pageTitle=${encodeURIComponent(pageTitle)}`)
            .then((res) => res.json())
            .then((json) => {
                const GAService = window.GAService || {};
                GAService.pageDataEvent(json.pageData);
            });
    } catch (e) {
        window.console.error(e);
    }
};

module.exports = {
    addShippingInformation,
    addBillingInformation,
    purchaseEvent,
    initializeEvents,
    pageMetaDataEvent,
    genericAddToCartEvent
};
